export const SEQUENCE = 'sequence';
